<template>
    <div>
        <v-card flat class="pa-1">
            <v-toolbar flat color="#FFF" short>
                <v-toolbar-title>Configurações do Sistema</v-toolbar-title>
            </v-toolbar>
            <v-tabs centered>
                <v-tab>
                    <v-icon left>mdi-wallet-travel</v-icon>
                    Empresa
                </v-tab>
                <v-tab>
                    <v-icon left>mdi-account-plus</v-icon>
                    Compradores
                </v-tab>
                <v-tab>
                    <v-icon left>mdi-truck</v-icon>
                    Fornecedores
                </v-tab>
                <v-tab>
                    <v-icon left>mdi-account-group</v-icon>
                    Grupos
                </v-tab>
                <v-tab>
                    <v-icon left>mdi-home-group</v-icon>
                    Grupo Filial
                </v-tab>
                
                <v-tab-item  class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <cfg-empresa></cfg-empresa>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item  class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <cfg-comprador @novoComprador="comprador = $event"></cfg-comprador>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item  class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <cfg-fornecedor :atualizarForn="comprador"></cfg-fornecedor>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item  class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <cfg-grupos @novoGrupo="grupo = $event"></cfg-grupos>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item  class="ma-0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <cfg-grupo-filial :atualizarGrupoFilial="grupo"></cfg-grupo-filial>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                
            </v-tabs>
        </v-card>
    </div>
</template>
<script>
    import CfgFornecedor from '../cfg/CfgFornecedor'
    import CfgComprador from '../cfg/CfgComprador'
    import CfgEmpresa from '../cfg/CfgEmpresa'
    import CfgGrupos from '../cfg/CfgGrupos'
    import CfgGrupoFilial from '../cfg/CfgGrupoFilial'

    export default {
        components: {
            CfgFornecedor, CfgComprador, CfgEmpresa, CfgGrupos, CfgGrupoFilial
        },
        name: "Cfg",

        data(){
            return{
                comprador: 0,
                grupo: 0
            }
        },

        created() {
            this.Helpers.verificarToken();
        },
    }
</script>
<style scoped>
</style>